// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.item[data-v-579a9cb8]{position:relative;padding:3.2rem;display:flex;flex-direction:column;align-items:center;width:100%}@media (min-width:1024px){.item[data-v-579a9cb8]{max-width:43.4rem}}.item-icon[data-v-579a9cb8]{width:5.8rem;height:5.8rem}.item-title[data-v-579a9cb8]{margin-top:1.6rem;color:var(--text-primary)}.item-text[data-v-579a9cb8]{color:var(--text-secondary);margin-top:.8rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
